import type { PostalAddressDetails } from './PostalAddressDetails';

export enum LocationType {
	Premise = 'PREMISE',
	GLN = 'GLN',
	CrossStreet = 'CrossStreet',
}

export interface Location extends VersionedLocation {
	type: LocationType.Premise;
	value: string;
}

export interface LocationV2 extends VersionedLocation {
	version: 2;

	premiseId?: string;
	gps?: GeolocationDetails;
	address?: PostalAddressDetails;

	// TODO: should we move this entirely into report answers, or will this be needed by web and police/fire?
	crossStreet?: CrossStreetDetails;

	// Treat as a non-premise report (will omit premise id when submitting)
	type?: LocationType;
}

export interface VersionedLocation {
	version?: number;
}

// Same general structure as the web Geolocation spec, but also allowing for undefined values to be sent
// https://developer.mozilla.org/en-US/docs/Web/API/GeolocationCoordinates
export interface GeolocationDetails {
	latitude: number;
	longitude: number;
	description?: string;
	accuracy?: number | null;
	altitude?: number | null;
	altitudeAccuracy?: number | null;
	speed?: number | null;
	heading?: number | null;
}

export interface CrossStreetDetails {
	street1?: string;
	street2?: string;
	city?: string;
	crossStreetAddress?: string;
	// State -- default to Michigan if not present
	state?: string;
}
